module.exports = __webpack_public_path__ + "img/avatar.17da80e.png";